import { Action, combineReducers, configureStore, ThunkAction } from '@reduxjs/toolkit';
import { globalSlice, GlobalState, userSlice, UserState } from './slices';
import { userPreferenceSlice, UserPreferenceState } from './slices/userpreference';
import { toastMessageSlice, ToastMessageState } from './slices/toast';
import { presentationExchangeSlice, PresentationExchangeState } from './slices/presentationExchange';
import { genericRequestSlice, GenericRequestState } from './slices/genericrequest';


export interface ApplicationState {
    globalState: GlobalState;
    userState: UserState;
    userPreferenceState: UserPreferenceState;
    toastMessageState: ToastMessageState;
    presentationExchangeState: PresentationExchangeState;
    genericRequestState: GenericRequestState;
}

const rootReducer = combineReducers<ApplicationState>({
    globalState: globalSlice.reducer,
    userState: userSlice.reducer,
    userPreferenceState: userPreferenceSlice.reducer,
    toastMessageState: toastMessageSlice.reducer,
    presentationExchangeState: presentationExchangeSlice.reducer,
    genericRequestState: genericRequestSlice.reducer,
});

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;
